// extracted by mini-css-extract-plugin
export var bottomTriangle = "forms-module--bottomTriangle--51e4a";
export var errorContainer = "forms-module--errorContainer--6c2cf";
export var formArea = "forms-module--formArea--e43eb";
export var formError = "forms-module--formError--6e068";
export var formGrid = "forms-module--formGrid--0895e";
export var headline = "forms-module--headline--fb0c0";
export var logo = "forms-module--logo--13c8d";
export var logoWrapper = "forms-module--logoWrapper--41796";
export var marginBottom25 = "forms-module--marginBottom25--6786d";
export var modalContent = "forms-module--modalContent--d36c7";